import { createContext, useContext, useState, FC, PropsWithChildren } from "react";

interface OccurrenceSelectorContextProps {
  isOccurrenceSelectorForcedOpen: boolean;
  setOccurrenceSelectorForcedOpen: (isOpen: boolean) => void;
}

const OccurrenceSelectorContext = createContext<OccurrenceSelectorContextProps>({
  isOccurrenceSelectorForcedOpen: false,
  setOccurrenceSelectorForcedOpen: () => {},
});

export const OccurrenceSelectorProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOccurrenceSelectorForcedOpen, setOccurrenceSelectorForcedOpen] = useState(false);

  return (
    <OccurrenceSelectorContext.Provider
      value={{
        isOccurrenceSelectorForcedOpen,
        setOccurrenceSelectorForcedOpen,
      }}
    >
      {children}
    </OccurrenceSelectorContext.Provider>
  );
};

export const useOccurrenceSelector = () => {
  return useContext(OccurrenceSelectorContext);
};
